// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";
import "./App.css";
import Rooms from "./pages/home/Room";
import Chat from "./pages/chat/Chat";

const App = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/chat-home" element={<Chat />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
